<template>
    <CollectForm
        v-if="formDefinition != null"
        :formDefinition="formDefinition"
        :readonly="readonly"
        @submit="submit"
    ></CollectForm>
</template>

<script>
import CollectForm from "./CollectForm/CollectForm.vue";
import request from "@/utils/RequestWithVant";

export default {
    components: { CollectForm },
    props: ["id"],
    data() {
        return {
            formDefinition: null,
            readonly: false,
        };
    },
    created() {
        if (this.id) {
            this.getTemplate();
        }
    },
    methods: {
        getTemplate: function () {
            request
                .showLoading()
                .get("./api/template/get/" + this.id)
                .then((res) => {
                    try {
                        let obj = JSON.parse(res.data.defJson);
                        // 初始化题目数据 - start
                        for (let i = 0; i < obj.itemList.length; i++) {
                            let item = obj.itemList[i];
                            item.index = i; // 序号
                            item.display = false; // 显示状态
                        }
                        // 初始化题目数据 - end
                        this.formDefinition = obj;
                        document.title = this.formDefinition.subject;
                    } catch (err) {
                        console.error(err);
                    }
                });
        },
        submit: function () {
            this.$toast("您正在预览模板");
        },
    },
};
</script>